export const baseURL = process.env.REACT_APP_BACKEND_URL;
